import {
  defaultLearningSchedule,
  parseTimeOfDay,
  type LearningSchedule,
} from '../shared/learning-schedule';
export * from '../shared/learning-schedule';
export const LEARNING_SCHEDULE_KEY = 'learning-schedule';

/** Legacy migration only; native preferences take precedence after the first save. */
export const readLearningSchedule = (storage: Storage): LearningSchedule => {
  try {
    const raw = storage.getItem(LEARNING_SCHEDULE_KEY);
    if (!raw) return { ...defaultLearningSchedule };
    const parsed = JSON.parse(raw) as Partial<LearningSchedule>;
    return {
      enabled:
        typeof parsed.enabled === 'boolean' ? parsed.enabled : defaultLearningSchedule.enabled,
      start:
        typeof parsed.start === 'string' && parseTimeOfDay(parsed.start) !== null
          ? parsed.start
          : defaultLearningSchedule.start,
      end:
        typeof parsed.end === 'string' && parseTimeOfDay(parsed.end) !== null
          ? parsed.end
          : defaultLearningSchedule.end,
      jobIds:
        parsed.jobIds === 'all'
          ? 'all'
          : Array.isArray(parsed.jobIds)
            ? parsed.jobIds
                .filter(
                  (id): id is string => typeof id === 'string' && id.length > 0 && id.length <= 256,
                )
                .slice(0, 10_000)
            : defaultLearningSchedule.jobIds,
    };
  } catch {
    return { ...defaultLearningSchedule };
  }
};
export const writeLearningSchedule = (storage: Storage, schedule: LearningSchedule): void => {
  try {
    storage.setItem(LEARNING_SCHEDULE_KEY, JSON.stringify(schedule));
  } catch {
    /* Native saving owns errors. */
  }
};
